module.exports = __webpack_public_path__ + "static/img/jinrong.5317ff0a.png";